import { MonitorKey } from '../view-models/monitor-models/monitor-key.type';

export class ConnectToRemoteMachine {
    constructor(
        public monitorKey: MonitorKey,
        public showAreaHeight: number,
        public showAreaWidth: number,
        public boundX: string,
        public boundY: string
    ) { }
}
